import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { ANNUAL } from 'self-service-api/constants/Terms';
import styled from 'styled-components';
import { getProductLevelFromApiNameString, getProductLineFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { hasPricingAndPurchasingSucceededSelector, hasPurchaseMotionsFailedSelector, isMerchCardCTAsDataLoadingSelector } from '../../selectors/LoadingStateSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import FallbackMerchCardCTAsContainer from '../merch-card/FallbackMerchCardCTAsContainer';
import MerchCardCTAsContainer from '../merch-card/MerchCardCTAsContainer';
import HighlightedMerchPriceDisplay from '../merch-card/price-display/HighlightedMerchPriceDisplay';
import { useSkuAdditionalUnits } from '../merch-card/useSkuAdditionalUnits';
const Container = styled.div.withConfig({
  displayName: "PPPMerchCard__Container",
  componentId: "sc-1pfdyep-0"
})(["max-width:312px;margin-top:32px;"]); // TODO merge this component and SuiteStarterCard.tsx

const PPPMerchCard = ({
  upgradePointApiName
}) => {
  const productLine = getProductLineFromApiNameString(upgradePointApiName);
  const productLevel = getProductLevelFromApiNameString(upgradePointApiName);
  const {
    additionalUnitSkuId,
    isAdditionalUnitSkuIdAQuantityPack,
    additionalUnitQuantity,
    skuId
  } = useSkuAdditionalUnits({
    productLevel,
    productLine
  });
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isMerchCardCTAsDataLoading = useSelector(isMerchCardCTAsDataLoadingSelector);
  const hasPurchaseMotionsFailed = useSelector(hasPurchaseMotionsFailedSelector);
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "p-bottom-4",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !hasPricingAndPurchasingSucceeded,
          heights: [16, 23, 16],
          widths: [60, 70, 130],
          className: "flex-column",
          Content: HighlightedMerchPriceDisplay,
          contentProps: {
            quantityPackQuantity: isAdditionalUnitSkuIdAQuantityPack ? additionalUnitQuantity : 0,
            quantityPackSkuId: isAdditionalUnitSkuIdAQuantityPack ? additionalUnitSkuId : null,
            queryParamTerm: ANNUAL,
            skuId,
            useLargePrice: false
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: isMerchCardCTAsDataLoading,
          isError: hasPurchaseMotionsFailed,
          heights: [47],
          Content: MerchCardCTAsContainer,
          contentProps: {
            additionalUnitQuantity: isAdditionalUnitSkuIdAQuantityPack ? additionalUnitQuantity : 0,
            additionalUnitSkuId,
            ctaStyles: {
              width: '100%',
              lineHeight: '23px'
            },
            productLine,
            queryParamTerm: ANNUAL,
            skuId,
            skipMCConfirmationPage: true
          },
          ErrorContent: FallbackMerchCardCTAsContainer,
          errorContentProps: {
            skuId
          }
        })
      })]
    })
  });
};

export default PPPMerchCard;